import React, { useEffect, useState } from "react";
import {  PaymentElement, useStripe,useElements} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import usePost from "../customHooks/usePost";
import config from "../services/config.json";
import { useNavigate } from "react-router-dom";

export default function CheckoutForm({data,onModelCLose}) {
     const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [res, apiMethod] = usePost()


const handleSubmit = async (event) => {
  event.preventDefault(); // Prevent default form submission

  if (!stripe || !elements) return;

  setIsLoading(true);

  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      // return_url: "http://localhost:3002/product/list", // Redirect after success
    },
    redirect: 'if_required',
  });

  if (error) {
    setMessage(error.message);
    toast.error(error.message);
    setIsLoading(false);
  } else if (paymentIntent && paymentIntent.status === "succeeded") {
    
    try {
      setMessage("Payment Successful!");
      let formdata = new FormData();
      for (let item in  data) {
        if(item == "attachments") {

        }
        else {
          formdata.append(item, data[item])
        }
        
      }
      for (let index = 0; index < data["attachments"].length; index++) {
        formdata.append(`attachments[]`, data["attachments"][index])
      }
      apiMethod(`dashboard/createProduct`, formdata);
    } catch (apiError) {
      setMessage("Failed to create product.");
      toast.error("Failed to create product.");
      setIsLoading(false);
    }
  }

  
};

useEffect(() => {
if(res.data) {
  setIsLoading(false);
  toast.success(res.data.message);
  navigate(`/${config.demo}product/list`);
}
}, [res.data])





  const paymentElementOptions = {
    layout: "accordion"
  }

  return (
    <div>
      <div className="px-3 py-2 flex items-center justify-between">
<div className="h3 text-[#ED2656] font-[700] text-[1.3rem]">Admin Charges</div>
<div onClick={onModelCLose} className="close cursor-pointer" href="#"><svg className="ml-auto" width="18" height="18" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.1992 3.24219L3.19922 40.2422" stroke="#000" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"></path><path d="M3.19922 3.24219L40.1992 40.2422" stroke="#000" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"></path></svg></div>
      </div>
    <form id="payment-form" onSubmit={handleSubmit}>

      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button className="btn btn-primary  block mt-5 mb-4 mx-5 submit" disabled={!stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner">Loading</div> : <>Pay <span className="font-[600]">AED 5</span></>}
        </span>
      </button>
    </form>
    </div>
  );
}